import Text from '@components/V3/forms/Text'
import omit from 'lodash/omit'
import React, {useMemo, useRef, useState} from 'react'

import useComponentWidth from '@hooks/useComponentWidth'
import getValue from './getValue'

import CountryPhone from './CountryPhone'

import {phoneCountryCodes} from './CountryPhone/codes'

export default function InternationalPhone(props) {
  //const websiteCountryCode = props.parentValue ? props.parentValue.countryCode : null
  const containerRef = useRef<HTMLDivElement>(null)
  const containerWidth = useComponentWidth(containerRef)
  const dialCodeRef = useRef<HTMLDivElement>(null)
  const dialCodeWidth = useComponentWidth(dialCodeRef)
  const [countryCode, setCountryCode] = useState('CL')
  const country = useMemo(
    () => phoneCountryCodes.find(country => country.countryCode === countryCode),
    [countryCode],
  )
  const starter = country.phoneCode
  const val = getValue(props.value, starter)
  const onChange = text => {
    const numbers = text.replace(/\D/g, '')
    if (!numbers) {
      props.onChange(null)
    } else {
      props.onChange(starter + numbers)
    }
  }

  const passingProps = omit(props, 'errorMessage')
  return (
    <div className="grid grid-cols-12 space-x-1 items-stretch" ref={containerRef}>
      <div className="col-span-3">
        <CountryPhone
          width={containerWidth}
          countryCode={countryCode}
          setCountryCode={countryCode => {
            //const country = phoneCountryCodes.find(country => country.countryCode === countryCode)
            //props.onChange(country.phoneCode + value)
            setCountryCode(countryCode)
          }}
          {...passingProps}
        />
      </div>
      <div className="col-span-9 relative flex-1 rounded-md shadow-sm">
        <Text
          {...passingProps}
          value={val}
          onChange={onChange}
          autoComplete="tel-national"
          leftPad={dialCodeWidth + 5}
        />
        <div
          ref={dialCodeRef}
          className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
        >
          <span className="text-gray-500">{country.phoneCode}</span>
        </div>
      </div>
    </div>
  )
}
